import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import { Color } from '@/constants/color';
import Badge from '@/ui/components/Badge';

import type { Props } from './types';

const ActiveFilters = ({ groups, onClearAll, onRemove }: Props) => {
  const activeGroups = groups.filter((group) => group.values.length);

  if (!activeGroups.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-x-1 gap-y-1 mb-1">
      {activeGroups.map((group) => (
        <span
          className="inline-flex flex-wrap items-center p-1 rounded-sm bg-white gap-x-1 gap-y-1"
          key={group.name}>
          <span className="text-xs">{group.label}: </span>

          {group.values.map(({ label, value }) => (
            <Badge
              color={Color.GRAY}
              key={`${group.name}-${value}`}
              text={
                <>
                  {label}{' '}
                  <button
                    aria-label={`Remove ${group.label} ${label}`}
                    className="ml-1 text-uniform-gray-600 hover:text-uniform-gray-800 focus:outline-none dark:text-uniform-gray-300 dark:hover:text-uniform-gray-100"
                    onClick={() => onRemove(group.name, value)}
                    type="button">
                    <FontAwesomeIcon icon={faTimesCircle} />
                  </button>
                </>
              }
            />
          ))}
        </span>
      ))}

      <div className="pl-2 text-sm">
        <button type="button" className="text-gray-500" onClick={onClearAll}>
          Clear all
        </button>
      </div>
    </div>
  );
};

export default memo(ActiveFilters);
